import React, { MouseEvent } from "react";

import { CounterBadge, LoadingOverlay, Typography } from "components";

type OpenTaskButtonProps = {
  count?: number;
  text?: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  className?: string;
  dataTestId?: string;
  isLoading?: boolean;
};

export const OpenTaskButton = ({ count, text, isLoading, onClick, className, dataTestId }: OpenTaskButtonProps) => {
  const Button = (
    <button className={`open-task-button ${className}`} onClick={!isLoading ? onClick : undefined} data-testid={dataTestId} type="button">
      <Typography variant="paragraph-m" className="open-task-button text">
        {text}
      </Typography>
      <CounterBadge count={count ?? 0} className="margin-left-50" />
    </button>
  );

  return isLoading ? <LoadingOverlay>{Button}</LoadingOverlay> : Button;
};
